import React from 'react';

/**
 * MagicCardFrame — Marco dorado como contenedor visual.
 *
 * El PNG del marco define el límite visual de la tarjeta.
 * No existe fondo oscuro fuera del marco.
 *
 * Variantes de marco (por aspect ratio):
 *   - "stat"      → frame-gold.png (1:1, para hero stats)
 *   - "small"     → frame-gold-landscape.png (3:2, para step cards)
 *   - "medium"    → frame-gold-landscape.png (3:2, para modes, transparency, telegram)
 *   - "wide"      → frame-gold-wide.png (para referral, free chests)
 *   - "banner"    → frame-gold-banner.png (para explainer, CTA)
 *
 * Props:
 *   - variant: string — tipo de marco (default: "medium")
 *   - children: ReactNode
 *   - hover: boolean (default: true)
 *   - className: string — clases extra para el contenedor exterior
 */

const FRAME_MAP = {
  stat: '/images/frame-gold.png',
  small: '/images/frame-gold-small.png',
  medium: '/images/frame-gold-medium.png',
  wide: '/images/frame-gold-wide.png',
  banner: '/images/frame-gold-banner.png',
};

export const MagicCardFrame = ({
  children,
  variant = 'medium',
  hover = true,
  className = '',
  ...rest
}) => {
  const frameSrc = FRAME_MAP[variant] || FRAME_MAP.medium;

  return (
    <div
      className={`frame-card ${hover ? 'frame-card-hover' : ''} ${className}`}
      style={{ backgroundImage: `url(${frameSrc})` }}
      {...rest}
    >
      <div className="card-inner">
        {children}
      </div>
    </div>
  );
};

export default MagicCardFrame;
